export default [
    {
        path: '/',
        redirect: { name: 'invoices.list' },
    },
    {
        path: '/list',
        name: 'list',
        component: () => import('@/views/Invoices/Invoices'),
    },
    {
        path: '/:id',
        name: 'detail',
        component: () => import('@/views/InvoiceDetail/InvoiceDetail'),
    },
    {
        path: '/:id/payment',
        name: 'payment',
        component: () => import('@/views/Payment/Payment'),
    },
    {
        path: '/payment/success',
        name: 'payment-success',
        component: () => import('@/views/PaymentSuccess/PaymentSuccess'),
    },
    {
        path: '/transactions/list',
        name: 'transactions',
        component: () => import('@/views/Invoices/Transactions/Transactions'),
    },
    {
        path: '/transactions/:id/detail',
        name: 'transaction-detail',
        component: () =>
            import('@/views/Invoices/TransactionDetail/TransactionDetail'),
    },
];
